import { render, staticRenderFns } from "./LicencePlateSearchTable.vue?vue&type=template&id=230aba1a&scoped=true"
import script from "./LicencePlateSearchTable.vue?vue&type=script&lang=js"
export * from "./LicencePlateSearchTable.vue?vue&type=script&lang=js"
import style0 from "./LicencePlateSearchTable.vue?vue&type=style&index=0&id=230aba1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230aba1a",
  null
  
)

export default component.exports